import { Component, Inject, OnInit } from '@angular/core';
import { SubCategoryModel } from '../../models/sub-category.model';
import { OptionTypeService } from '../../services/option-type.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-add-edit-sponsors',
  templateUrl: './add-edit-sponsors.component.html',
  styleUrls: ['./add-edit-sponsors.component.scss']
})
export class AddEditSponsorsComponent implements OnInit {
  form = new FormGroup({});
  fields: FormlyFieldConfig[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SubCategoryModel,
    private dialogRef: MatDialogRef<AddEditSponsorsComponent>,
    private service: OptionTypeService) { }

  ngOnInit(): void {
    this.fields = this.service.buildSubCategoryForm({ ...this.data }, 'Sponsor');
  }

  save(): void {
    this.dialogRef.close(this.data);
  }

  close(): void {
    this.dialogRef.close(null);
  }

}
